// removed by extract-text-webpack-plugin
module.exports = {"menu":"src-layouts----menus-module---menu---U3fz7","activeItem":"src-layouts----menus-module---activeItem---3P3i3","inactiveItem":"src-layouts----menus-module---inactiveItem---3LMzb","smallMenu":"src-layouts----menus-module---smallMenu---2jh4D","closed":"src-layouts----menus-module---closed---2ROJY"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/menus.module.css
// module id = 618
// module chunks = 114276838955818